import { reportBi } from '../bi';
import { createMobileReparentingBlockPlugin } from '../plugin';
import { getRestrictedZones } from '../store';
import { getIsMobileBlockReparentingEnabled } from '../utils/common';
import { resetToInitialPositionIfNeeded } from './resetToInitialPosition';

export const createMobileBlockReparentingApi = () => ({
  dragPlugin: createMobileReparentingBlockPlugin(),
  reportBi,
  getIsMobileBlockReparentingEnabled,
  getRestrictedZones,
  resetToInitialPositionIfNeeded,
});

export type MobileBlockReparentingApi = ReturnType<
  typeof createMobileBlockReparentingApi
>;
